import { EnumClaimRequestStatus } from "constants/enums/claim-request-status";
import { EnumHospitalType } from "constants/enums/hospital_types";
import { EnumHospitalImportStatus } from "constants/enums/hospital_import_status";
import { EnumEmployeeDelegationMode } from "constants/enums/employee-delegation-mode";

const th = {
  translation: {
    client: {
      success: "ทำรายการสำเร็จ",
      enum: {
        paymentCycleStatus: {
          IN_PROGRESS: "ดำเนินการ",
          CLOSED: "ปิดรอบ",
        },
        claimRequestStatus: {
          [EnumClaimRequestStatus.APPROVED]: "อนุมัติ",
          [EnumClaimRequestStatus.REJECTED]: "ไม่อนุมัติ",
          [EnumClaimRequestStatus.WAITING]: "รออนุมัติ",
        },
        hospitalImportStatus: {
          [EnumHospitalImportStatus.IMPORTING]: "กำลังนำเข้า",
          [EnumHospitalImportStatus.PROCESSED]: "ส่งเบิกแล้ว",
          [EnumHospitalImportStatus.CANCELED]: "ยกเลิก",
          [EnumHospitalImportStatus.ERROR]: "ผิดพลาด",
        },
        employeeDelegationMode: {
          [EnumEmployeeDelegationMode.ALL]: "ได้ทุกคน",
          [EnumEmployeeDelegationMode.CHOOSE]: "ได้บางคน",
        },
      },
      enhancers: {
        withPreventLeaveDirtyForm: {
          cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
          cancelConfirm: "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
          close: "ปิดหน้าต่างนี้",
          canceledEdit: "ยกเลิกการแก้ไข",
        },
      },
      api: {
        modal401Title: "การเข้าสู่ระบบหมดอายุ",
        modal401Children:
          "การเข้าสู่ระบบหมดอายุ กรุณาทำการเข้าสู่ระบบใหม่อีกครั้ง",
        modal401OkButtonLabel: "เข้าสู่ระบบ",
        modalSessionRevokedTitle: "เข้าสู่ระบบจากอุปกรณ์อื่น",
        modalSessionRevokedChildren:
          "บัญชีนี้มีการเข้าสู่ระบบจากอุปกรณ์อื่น กรุณาเข้าสู่ระบบอีกครั้ง",
        modalSessionRevokedOkButtonLabel: "เข้าสู่ระบบ",
        modal403Title: "เกิดข้อผิดพลาด",
        modal403Children:
          "บทบาทผู้ใช้งานของคุณไม่มีสิทธิ์ใช้งานส่วนนี้ กรุณาเข้าสู่ระบบอีกครั้ง",
        modal403OkButtonLabel: "เข้าสู่ระบบ",
        modal500Title: "เกิดข้อผิดพลาด",
        modal500OkButtonLabel: "ตกลง",
        modalConnectionFailedTitle: "เชื่อมต่อระบบไม่สำเร็จ",
        modalConnectionFailedChildren:
          "ไม่สามารถเชื่อมต่อกับระบบได้ในขณะนี้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่อีกครั้ง",
        modalConnectionFailedOkButtonLabel: "ลองใหม่อีกครั้ง",
      },
      pages: {
        main: {
          admins: {
            index: {
              title: "ผู้ดูแลระบบ",
              home: "หน้าแรก",
              addButton: "เพิ่มผู้ดูแลระบบ",
              admins: "รายชื่อผู้ดูแลระบบ",
              deleteButton: "ต้องการลบข้อมูลผู้ดูแลระบบ",
              removeTitle: "ลบข้อมูลผู้ดูแลระบบ",
              cancel: "ปิดหน้าต่างนี้",
              removeAdmin: "ลบข้อมูลทั้งหมด",
              remove: "ลบข้อมูลสำเร็จ",
              titleRemove: "ข้อมูลของผู้ดูแลระบบ",
              removeText:
                "รวมทั้งรายงานที่สร้างไว้ส่วนตัวจะถูกลบและไม่สามารถกู้คืนได้",
              columns: {
                fullName: "ชื่อ นามสกุล",
                email: "อีเมล",
                status: "สถานะ",
                code: "รหัส",
                lastActiveAt: "ใช้งานล่าสุด",
                createdAt: "สร้างเมื่อ",
                updatedAt: "แก้ไขเมื่อ",
                role: "บทบาท",
                values: {
                  availableStatus: {
                    active: "ใช้งาน",
                    inactive: "ไม่ใช้งาน",
                  },
                },
              },
            },
            new: {
              home: "หน้าแรก",
              rootPath: "ผู้ดูแลระบบ",
              title: "เพิ่มผู้ดูแลระบบ",
              header: "กรอกอีเมลผู้ดูแลระบบเพื่อส่งลิงค์เข้าใช้งาน",
              link: "ลิงก์เพื่อเข้าใช้งานระบบจะถูกส่งไปที่อีเมลนี้",
              send: "ส่งเมล",
              cancel: "ยกเลิก",
              email: "อีเมล",
              role: "บทบาท",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            edit: {
              title: "ข้อมูลทั่วไป",
              home: "หน้าแรก",
              rootPath: "ผู้ดูแลระบบ",
              status: "สถานะ",
              cancel: "ยกเลิก",
              save: "บันทึก",
              cantEditYourself:
                "การแก้ไขสถานะและบทบาทไม่สามารถทำได้ด้วยตัวเอง ต้องให้ Admin ที่มี permission แก้ไข permission ของ Admin ทำให้เท่านั้น เช่น Super Admin",
              firstName: "ชื่อ",
              lastName: "นามสกุล",
              role: "บทบาท",
              email: "อีเมล",
              available: "ใช้งานระบบ",
            },
          },
          authentication: {
            LoginPage: {
              or: "หรือ",
              title: "eBenefits",
              title1: "กรอกอีเมลรับรหัส OTP เพื่อเข้าสู่ระบบ",
              title2: "กรอกอีเมลรับรหัส OTP เพื่อลงทะเบียนใช้งาน",
              title3: "กรอกอีเมลและรหัสผ่านเพื่อเข้าสู่ระบบ",
              emailField: "อีเมล",
              passwordField: "รหัสผ่าน",
              getOtp: "รับรหัส OTP",
              invalidEmail: "รูปแบบอีเมลไม่ถูกต้อง",
              signInWithAzureAd: "เข้าสู่ระบบด้วย Azure AD",
              logoutAzureAd: "ออกจากระบบ Azure AD",
              ResetPassword: "ลืมรหัสผ่าน",
              login: "เข้าสู่ระบบ",
            },
            VerifyOtp: {
              title: "กรอกรหัส OTP เพื่อเข้าสู่ระบบ",
              otpInfo:
                "กรอกรหัส OTP ที่ได้รับทาง {{currentEmail}} (OTP มีอายุการใช้งาน {{otpExpireInMin}} นาที)",
              otp: "OTP",
              refCode: "เลขอ้างอิง:{{refCode}}",
              notReceiveOtp: "ไม่ได้รหัส OTP?",
              retryOtp: "ขอ OTP อีกครั้ง",
              canRetryIn: "ขออีกครั้งใน {{timeLeft}} วินาที",
              login: "เข้าสู่ระบบ",
              changeEmail: "เปลี่ยนอีเมล",
              home: "กลับไปหน้าแรก",
              otpMustNumber: "รูปแบบ otp ไม่ถูกต้อง",
            },
            ResetPassword: {
              home: "กลับไปหน้าแรก",
              title: "กรอกที่อยู่อีเมล",
              title2: "ระบบจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ไปทางอีเมล",
              emailField: "อีเมล",
              resetPassword: "รีเซตรหัสผ่าน",
              modal: {
                title: "ส่งอีเมลสำเร็จ",
                content: "โปรดตรวจสอบอีเมลของคุณเพื่อตั้งรหัสผ่านใหม่",
                button: "ตกลง",
              },
            },
            SetupPassword: {
              title: "สร้างรหัสผ่านสำหรับ",
              passwordField: "รหัสผ่าน",
              confirmPasswordField: "ยืนยันรหัสผ่าน",
              setupPassword: "สร้างรหัสผ่าน",
              suggestText: {
                1: "ต้องยาว 8-16 หลัก",
                2: "ตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว",
                3: "ตัวเลขอย่างน้อย 1 ตัว",
                4: "ไม่รองรับภาษาไทยและสัญลักษณ์พิเศษ",
              },
              modal: {
                title: "ตั้งรหัสผ่านใหม่สำเร็จ",
                content: "โปรดเข้าสู่ระบบเพื่อใช้งาน",
                button: "ตกลง",
                error: {
                  title: "เกิดข้อผิดพลาด",
                  button: "ตกลง",
                },
              },
            },
          },
          roles: {
            index: {
              title: "บทบาท",
              home: "หน้าแรก",
              addButton: "เพิ่มบทบาท",
              list: "รายการบทบาท",
              deleteRole: "ข้อมูล บทบาท จะถูกลบและไม่สามารถกู้คืนได้",
              deletedRole: "ลบข้อมูล",
              description: "คำอธิบาย",
              amount: "จำนวนผู้ใช้",
              updatedAt: "แก้ไขล่าสุด",
              deleteRoleSuccess: "ลบข้อมูลสำเร็จ",
              alreadyInUse: "ไม่สามารถลบได้ มีผู้ดูแลระบบใช้งานอยู่",
              cancel: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
            },
            new: {
              addRole: "เพิ่มบทบาท",
              role: "บทบาท",
              home: "หน้าแรก",
              title: "ข้อมูลทั่วไป",
              detail: "รายละเอียดบทบาท",
              scope: "ขอบเขตการใช้งานระบบ",
              reportScope: "ขอบเขตการออกรายงาน",
              roleTitle: "ชื่อบทบาท",
              description: "คำอธิบาย",
              syncingNotification: "รับแจ้งเตือนเมื่อการ Sync ไม่สำเร็จ",
              read: "ดูข้อมูล",
              edit: "แก้ไขข้อมูล",
              activation: "เปิด-ปิด รอบการจ่ายเงิน",
              admin: "จัดการผู้ดูแลระบบ",
              permission: "จัดการบทบาท",
              report: "จัดการออกรายงาน",
              setting: "จัดการ Setting",
              employee: "จัดการพนักงาน",
              budget: "จัดการวงเงินสวัสดิการ",
              request: "จัดการรายการขอเบิก",
              hospital: "จัดการการเบิกจากโรงพยาบาล",
              agent: "จัดการกำหนดสิทธิ์ทำแทน",
              payment: "จัดการรอบการจ่ายเงิน",
              exportAllReport: "ออกรายงานได้ทั้งหมด",
              medical: "ค่ารักษาพยาบาล",
              medicalReimbursementPerEmployee:
                "รายงานการเบิกค่ารักษาพยาบาล (รายพนักงาน)",
              medicalReimbursementDepartment:
                "รายงานการเบิกค่ารักษาพยาบาลตามฝ่าย/สังกัด",
              support: "ค่าช่วยเหลือบุตร",
              supportChildPerEmployee: "รายงานเงินช่วยเหลือบุตร (รายพนักงาน)",
              supportChildUnder18PerEmployee:
                "รายงานเงินช่วยเหลือบุตรที่ยังไม่เกิน 18 ปีบริบูรณ์ (รายพนักงาน)",
              supportChildHistoryDisbursement:
                "รายงานประวัติการเบิกเงินช่วยเหลือบุตร",
              education: "ค่าช่วยเหลือการศึกษาบุตร",
              educationChildPerEmployee:
                "รายงานการเบิกค่าช่วยเหลือการศึกษาบุตร (รายพนักงาน)",
              compensation: "เงินชดเชยพนักงาน",
              compensationFuneralDisbursementSupport:
                "รายงานการเบิกค่าช่วยเหลือจัดการงานศพ (3 เท่า) ",
              compensationFuneralDisbursement: "รายงานการเบิกค่าเจ้าภาพงานศพ",
              compensationFuneralDisbursementEquipment:
                "รายงานการเบิกค่าอุปกรณ์เคารพศพ",
              compensationFuneralPayrollReport: "สรุปรายการปรับปรุงเงินเดือน",
              compensationFuneralBudgetReport: "สรุปวงเงินคงเหลือ (รายพนักงาน)",
              summary: "รายงานสรุปสำหรับส่งงานการเงินและบัญชี",
              summaryMedicalReimbursementDepartment:
                "สรุปการเบิกค่ารักษาพยาบาลตามฝ่าย/สังกัด",
              summaryChildEducationReimbursementDepartment:
                "สรุปการเบิกค่าเล่าเรียนบุตรตามฝ่าย/สังกัด",
              summaryChildSupportReimbursementDepartment:
                "สรุปการเบิกเงินช่วยเหลือบุตรตามฝ่าย/สังกัด",
              summaryAllEachTimes: "สรุปรายการเบิกทั้งหมด รายครั้ง",
              affect: "รายงานกระทบยอดการเบิก",
              affectChildSupportIncrease:
                "รายงานเงินช่วยเหลือบุตร (เพิ่มขึ้น) ตามฝ่าย/สังกัด",
              affectChildSupportReduce:
                "รายงานเงินช่วยเหลือบุตร (ลดลง) ตามฝ่าย/สังกัด",
              cancel: "ยกเลิกรายการขอเบิก",
              cancelButton: "ยกเลิก",
              save: "บันทึก",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
              partner: "จัดการโรงพยาบาลพันธมิตร",
            },
            edit: {
              home: "หน้าแรก",
              indexTitle: "บทบาท",
              editRole: "แก้ไขบทบาท",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
              detail: "รายละเอียดบทบาท",
              scope: "ขอบเขตการใช้งานระบบ",
              cancelButton: "ยกเลิก",
              save: "บันทึก",
              roleTitle: "ชื่อบทบาท",
              description: "คำอธิบาย",
            },
          },
          insurances: {
            index: {
              home: "หน้าแรก",
              title: "จัดการชุดแบบประกัน",
              addButton: "สร้างชุดแบบประกัน",
              list: "ชุดแบบประกัน",
              year: "ปีที่ใช้งาน",
              amount: "จำนวนแบบประกัน",
              updatedAt: "วันที่แก้ไขล่าสุด",
              status: "สถานะ",
              modalDescription:
                "โปรดระบุปีที่ใช้งาน (ปีที่ใช้งานต้องไม่ซ้ำกับที่มีอยู่แล้วในระบบ)",
              duplicateTitle: "คัดลอกชุดแบบประกัน",
              duplicateDescription:
                "ระบบจะคัดลอกชุดแบบประกัน {{year}} มาสร้างเป็นต้นแบบของชุดแบบประกันในชื่อ {{secondYear}} เพื่อให้แก้ไขและใช้งานต่อไป",
              cancel: "ยกเลิก",
              duplicateSuccess: "ทำรายการสำเร็จ",
              alreadyInUse: "ไม่สามารถลบได้ มีชุดแบบประกันปีนี้แล้ว",
              reset: "รีเซ็ต",
              filter: "กรอง",
              reEditing: "แก้ไขการจัดชุดประกันที่เผยแพร่แล้ว",
              reEditingInfo:
                "การแก้ไขจะทำให้ HR ไม่สามารถสร้าง enrollment ด้วยชุดประกันนี้ได้ จนกว่าจะมีการเผยแพร่ชุดประกันใหม่อีกครั้ง",
              edit: "แก้ไข",
              deleteTitle: "ลบชุดแบบประกัน",
              deleteSuccess: "ทำรายการสำเร็จ",
              deleteDescription: "ต้องการลบข้อมูลชุดแบบประกันปี {{year}}",
              state: {
                all: "ทั้งหมด",
                draft: "แบบร่าง",
                published: "เผยแพร่",
                editing: "แก้ไข",
                active: "ใช้งาน",
                closed: "ปิด",
              },
            },
            package: {
              new: {
                save: "บันทึก",
                cancel: "ยกเลิก",
                name: "ชื่อ Package",
                ipd: "ประกัน IPD",
                opd: "ประกัน OPD",
                dental: "ประกัน Dental",
                remark: "หมายเหตุ",
              },
            },
          },
          settings: {
            index: {
              home: "หน้าแรก",
              settingMenu: "การตั้งค่าระบบ",
              title: "ตั้งค่าข้อมูลเกี่ยวกับ Belive",
              titleDetail:
                "รายละเอียดจะนำไปแสดงในหน้า ตั้งค่า -> เกี่ยวกับ Belive ของแอปพลิเคชั่น",
              logo: "โลโก้บริษัท",
              logoDetail: "แนะนำให้ใช้รูป .jpg ขนาดอย่างน้อย xxx x yyy px ",
              syncSetting: "ตั้งค่าการ Sync ข้อมูลพนักงาน",
              syncSettingDetail:
                "ข้อมูลพนักงานจะถูกใช้ในขั้นตอนการสร้าง Enrollment ของ HR",
              reportSetting: "ตั้งค่าการสร้างรายงานอัตโนมัติ",
              reportSettingDetail: "ใช้ในขั้นตอนการสร้างรายงานอัตโนมัติของระบบ",
              createReport: "สร้างรายงานทุก",
              addImage: "เพิ่มรูป",
              editImage: "แก้ไข",
              name: "ชื่อบริษัท",
              nameTh: "ชื่อบริษัท (Th)",
              nameEn: "ชื่อบริษัท (En)",
              description: "รายละเอียดบริษัท",
              descriptionTh: "รายละเอียดบริษัท (Th)",
              descriptionEn: "รายละเอียดบริษัท (En)",
              email: "อีเมล",
              phoneNumber: "เบอร์โทรศัพท์",
              cancel: "ยกเลิก",
              save: "บันทึก",
              saveSuccess: "ทำรายการสำเร็จ",
              syncEmData: "Sync ข้อมูลพนักงานทุก",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
            },
          },
          reports: {
            index: {
              home: "หน้าแรก",
              reportMenu: "ออกรายงาน",
              report: "สร้างรายงานกระทบยอดการเบิก",
              reportSummary: "สร้างรายงานสรุป",
              filter: "กรอง",
              filterTitle: "ตัวกรอง",
              remove: "ลบรายงานสำเร็จ",
              removeTitle: "ลบรายงาน",
              show: "แสดง",
              hide: "ซ่อน",
              reset: "รีเซ็ท",
              removeButtonOK: "ลบรายงาน",
              removeButtonCancel: "ปิดหน้าต่างนี้",
              downloadSuccess: "ดาวน์โหลดรายงานสำเร็จ",
              columns: {
                year: "ปีที่ใช้งาน",
                reportName: "ชื่อรายงาน",
                reportType: "ประเภทรายงาน",
                startDate: "วันที่เริ่มต้น",
                endDate: "วันที่สิ้นสุด",
                state: "สถานะ",
                createdAt: "วันที่สร้าง",
              },
              modal: {
                title: "ปรับสถานะรายงาน",
                description: "ปรับสถานะการส่งรายงานเป็น",
                statusSend: "ส่งแล้ว",
                statusNotSend: "ยังไม่ได้ส่ง",
                cancelButtonLabel: "ยกเลิก",
                okButtonLabel: "ยืนยัน",
                generating: "กำลังสร้างรายงาน",
                waitingOptions: "รอจัดการ",
              },
            },
          },
          employee: {
            index: {
              home: "หน้าแรก",
              title: "พนักงาน",
              syncButton: "อัพเดตข้อมูลพนักงาน",
              filter: {
                title: "ตัวกรอง",
                show: "แสดง",
                hide: "ซ่อน",
                fullName: "ชื่อ นามสกุล",
                email: "อีเมล",
                status: "สถานะ",
                code: "รหัส",
                department: "ฝ่าย/สังกัด",
                employmentStartDate: "วันที่เริ่มงานตั้งแต่",
                employmentFinishDate: "วันที่สิ้นสุดการทำงานตั้งแต่",
                endDate: "จนถึงวันที่",
                reset: "รีเซ็ต",
                confirm: "กรอง",
              },
              columns: {
                fullName: "ชื่อ นามสกุล",
                email: "อีเมล",
                code: "รหัส",
                department: "ฝ่าย/สังกัด",
                employmentStartDate: "วันที่เริ่มงาน",
                employmentFinishDate: "วันที่สิ้นสุดการทำงาน",
                role: "บทบาท",
                values: {
                  availableStatus: {
                    active: "ใช้งาน",
                    inactive: "ไม่ใช้งาน",
                  },
                },
              },
              syncEmployeeLoading: "กำลังอัพเดตข้อมูลพนักงาน",
              syncEmployeeError:
                "อัพเดทข้อมูลพนักงานไม่สำเร็จ กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ",
            },
            edit: {
              title: "รายละเอียกพนักงาน",
              home: "หน้าแรก",
              rootPath: "พนักงาน",
              cancel: "ย้อนกลับ",
              fullName: "ชื่อ นามสกุล",
              email: "อีเมล",
              status: "สถานะ",
              code: "รหัส",
              phoneNumber: "เบอร์โทรศัพท์",
              department: "ฝ่าย/สังกัด",
              employmentStartDate: "วันที่เริ่มงาน",
              employmentFinishDate: "วันที่สิ้นสุดการทำงาน",
            },
          },
          budget: {
            index: {
              home: "หน้าแรก",
              title: "วงเงินสวัสดิการ",
              filter: {
                title: "ตัวกรอง",
                show: "แสดง",
                hide: "ซ่อน",
                fullName: "ชื่อ นามสกุล",
                code: "รหัส",
                reset: "รีเซ็ต",
                confirm: "กรอง",
                yearlyRequest: "ปีที่ได้รับสวัสดิการ",
                allYears: "ทั้งหมด",
              },
              columns: {
                fullName: "ชื่อ นามสกุล",
                code: "รหัส",
                year: "ปี",
                companyBudget: "สิทธิ์บริษัท",
                budget: "คงเหลือ",
                companyDentalBudget: "สิทธิ์ทันตกรรม",
                dentalBudget: "คงเหลือ",
              },
            },
            edit: {
              title: "รายละเอียดวงเงินการเบิกสวัสดิการ",
              home: "หน้าแรก",
              rootPath: "วงเงินการเบิกสวัสดิการ",
              cancel: "ย้อนกลับ",
              code: "รหัส",
              fullName: "ชื่อ นามสกุล",
              year: "ปีที่ได้รับสวัสดิการ",
              companyBudget: "สิทธิ์บริษัทตั้งต้น",
              budget: "สิทธิ์บริษัทคงเหลือ",
              companyDentalBudget: "สิทธิ์ทันตกรรมตั้งต้น",
              dentalBudget: "สิทธิ์ทันตกรรมคงเหลือ",
            },
          },
          request: {
            index: {
              home: "หน้าแรก",
              title: "รายการขอเบิก",
              filter: "กรอง",
              filterTitle: "ตัวกรอง",
              remove: "ลบสำเร็จ",
              removeTitle: "ลบรายงาน",
              show: "แสดง",
              hide: "ซ่อน",
              reset: "รีเซ็ท",
              refId: "เลขอ้างอิง",
              claimRequester: "ผู้ขอเบิก",
              department: "ฝ่าย/สังกัด",
              claimType: "ประเภทสวัสดิการ",
              claimName: "ชื่อสวัสดิการ",
              createdAt: "วันที่สร้าง",
              status: "สถานะ",
              disease: "โรค",
              refNo: "เลขที่ใบเสร็จ",
              transferDate: "วันที่ตามใบเสร็จ",
            },
            detail: {
              title: "รายละเอียดรายการขอเบิก",
              home: "หน้าแรก",
            },
          },
          paymentCycles: {
            index: {
              home: "หน้าแรก",
              title: "รอบการจ่ายเงิน",
              addPaymentCycle: "เพิ่มรอบการจ่ายเงิน",
              helperText:
                '*สามารถลบได้เฉพาะรอบที่มีสถานะ "ดำเนินการ" และไม่มีคำร้องอยู่ในรอบเท่านั้น',
            },
            detail: {
              index: {
                title: "จัดการคำร้อง",
                home: "หน้าแรก",
                paymentCycle: "รอบการจ่ายเงิน",
                claimRequests: "รายการขอเบิก",
              },
              SummaryDetail: {
                requestAmount: "จำนวนคำร้อง",
                approvedAmount: "ยอดที่อนุมัติ",
              },
              PaymentCycleDetail: {
                name: "ชื่อรอบ",
                paymentDate: "วันที่จ่ายเงิน",
                info: "*ทุกคำร้องที่อยู่ในรอบจะถูกปรับวันที่จ่ายเงินเป็นวันนี้",
                okButtonLabel: "บันทึก",
                title: "รายละเอียดรอบ",
              },
              PaymentCycleDetailTable: {
                title: "คำขอเบิกที่จ่ายเงินรอบนี้",
                waitingTitle: "คำร้องที่รอจัดการ",
                helperText: "*เลือกรายการที่ต้องการเพื่อแก้ไขรอบของคำร้องได้",
                refId: "เลขอ้างอิง",
                claimRequester: "ผู้ขอเบิก",
                department: "ฝ่าย/สังกัด",
                claimType: "ประเภทสวัสดิการ",
                claimName: "ชื่อสวัสดิการ",
                createdAt: "วันที่สร้าง",
                status: "สถานะ",
                disease: "โรค",
                refNo: "เลขที่ใบเสร็จ",
                transferDate: "วันที่ตามใบเสร็จ",
                requestAmount: "จำนวนเงินที่เบิก",
              },
              PaymentCycleDetailFilters: {
                startCreatedAt: "วันที่สร้างรายการตั้งแต่",
                endCreatedAt: "จนถึงวันที่",
                startPaymentDate: "วันที่จ่ายเงินตั้งแต่",
                endPaymentDate: "จนถึงวันที่",
                status: "สถานะการอนุมัติ",
                department: "ฝ่าย/สังกัด",
                requester: "ผู้ขอเบิก",
              },
              PaymentCycleSwitcher: {
                waitingOptions: "รอจัดการ",
                selected: "{{selected}} รายการที่ถูกเลือก:",
                moveAllTo: "ย้ายทั้งหมดไปยังรอบ",
                pleaseFillCycle: "โปรดระบุรอบ",
                moveAndSave: "ย้ายและบันทึก",
                errorModal: {
                  title: "ย้ายคำร้องไม่สำเร็จ",
                  info1: "ทุกคำร้องที่จะย้ายเข้ารอบการจ่ายเงินต้องมีสถานะเป็น",
                  info2: "เท่านั้น ",
                  info3: "กรุณาตรวจสอบและดำเนินการอีกครั้ง",
                  confirm: "ตกลง",
                },
                changePaymentModal: {
                  title: "ย้ายคำร้องไปรอบอื่น",
                  info1: "ต้องการย้ายคำร้อง",
                  info2: "ไปยังรอบการจ่ายเงิน",
                  info3: "หรือไม่",
                  confirm: "ย้ายและบันทึก",
                  cancel: "ยกเลิก",
                },
              },
            },
            PaymentCycleFilters: {
              confirm: "กรอง",
              reset: "รีเซ็ต",
              name: "ชื่อรอบ",
              status: "สถานะ",
              startPaymentDate: "วันที่จ่ายเงินตั้งแต่",
              endPaymentDate: "จนถึงวันที่",
              statusOptions: {
                IN_PROGRESS: "ดำเนินการ",
                CLOSED: "ปิดรอบ",
              },
            },
            PaymentCycleTable: {
              columns: {
                name: "ชื่อรอบ",
                requestAmount: "จำนวนคำร้อง",
                requestTotalPaymentAmount: "ยอดที่อนุมัติ",
                paymentDate: "วันที่จ่ายเงิน",
                status: "สถานะ",
              },

              confirmDeleteModal: {
                info1: "ต้องการให้ลบรอบการจ่ายเงิน",
                info2: "หรือไม่",
                warningInfo: "*ข้อมูลจะถูกลบและไม่สามารถกู้คืนได้",
                removePaymentCycle: "ลบรอบการจ่ายเงิน",
                cancelDelete: "ยกเลิก",
                confirmDelete: "ลบรอบการจ่ายเงิน",
              },
              changeStatusToCloseModal: {
                title: "ปรับสถานะรอบการจ่ายเงิน",
                info1: "ต้องการปรับสถานะรอบการจ่ายเงิน",
                info2: "เป็น",
                info3: "หรือไม่",
                subInfo:
                  '*รอบการเบิกนี้จะไม่สามารถแก้ไขได้ ยกเว้นจะปรับสถานะกลับเป็น "ดำเนินการ"',
                cancel: "ยกเลิก",
                confirm: "ปิดรอบ",
              },
              changeStatusToInProgressModal: {
                title: "ปรับสถานะรอบการจ่ายเงิน",
                info1: "ต้องการปรับสถานะรอบการจ่ายเงิน",
                info2: "เป็น",
                info3: "เพื่อแก้ไขข้อมูลหรือไม่",
                cancel: "ยกเลิก",
                confirm: "ปรับสถานะเป็นดำเนินการ",
              },
            },
            CreatePaymentCycleModal: {
              createPaymentCycle: "เพิ่มรอบการจ่ายเงิน",
              name: "ชื่อรอบ",
              paymentDate: "วันที่จ่ายเงิน",
              cancelButtonLabel: "ยกเลิก",
              okButtonLabel: "เพิ่มรอบการจ่ายเงิน",
            },
          },
          hospitalImport: {
            index: {
              home: "หน้าแรก",
              title: "การเบิกจากโรงพยาบาล",
              addHospitalImport: "นำเข้าข้อมูล",
              template: "เทมเพลต",
            },
            detail: {
              index: {
                title: "รายการขอเบิก",
                hospitalImport: "การเบิกจากโรงพยาบาล",
                home: "หน้าแรก",
                refId: "เลขอ้างอิง",
                claimRequester: "ผู้ขอเบิก",
                department: "ฝ่าย/สังกัด",
                claimName: "ชื่อสวัสดิการ",
                hospitalName: "ชื่อโรงพยาบาล",
                hospitalType: "ประเภทโรงพยาบาล",
                disease: "โรค",
                dayAmount: "จำนวนวันที่นอน รพ.",
                receiptDate: "วันที่ตามใบเสร็จ",
                transferDate: "วันที่จ่ายเงิน",
                refNo: "เลขที่ใบเสร็จ",
                receiptBook: "เล่มที่ใบเสร็จ",
                amount: "ค่าใช้จ่ายรวม",
                download: "ดาวน์โหลดไฟล์ต้นฉบับ",
                cancelAllRequest: "ยกเลิกการเบิกทั้งหมด",
                displayErrorLogs: "ดู Error log",
                downloadErrorlogs: "ดาวน์โหลด Error log",
                errorLogs: "Error log",
                close: "ปิด",
                cancelAllRequestModal: {
                  info1: "ต้องการยกเลิกทุกคำร้องในการนำเข้า",
                  info2: "หรือไม่",
                  warningInfo:
                    "*การยกเลิกจะส่งผลต่อวงเงินคงเหลือปัจจุบันของพนักงาน",
                  close: "ปิดหน้าต่างนี้",
                  confirm: "ยกเลิกคำร้อง",
                },
                cancelAllRequestSuccess: "ทำรายการสำเร็จ",
              },
            },
            filters: {
              name: "ชื่อการนำเข้า",
              status: "สถานะ",
              startDate: "วันที่เริ่มต้น",
              endDate: "วันที่สิ้นสุด",
              statusOptions: {
                [EnumHospitalImportStatus.IMPORTING]: "กำลังนำเข้า",
                [EnumHospitalImportStatus.PROCESSED]: "ส่งเบิกแล้ว",
                [EnumHospitalImportStatus.CANCELED]: "ยกเลิก",
                [EnumHospitalImportStatus.ERROR]: "ผิดพลาด",
              },
            },
            table: {
              columns: {
                name: "ชื่อการนำเข้า",
                status: "สถานะ",
                importDate: "วันที่นำเข้า",
                totalRecords: "จำนวนคำร้อง",
              },
              statusOptions: {
                [EnumHospitalImportStatus.IMPORTING]: "กำลังนำเข้า",
                [EnumHospitalImportStatus.PROCESSED]: "ส่งเบิกแล้ว",
                [EnumHospitalImportStatus.CANCELED]: "ยกเลิก",
                [EnumHospitalImportStatus.ERROR]: "ผิดพลาด",
              },
              download: "ดาวน์โหลด",
              viewDetail: "ดูรายละเอียด",
              delete: "ลบ",
              deleteSuccess: "ลบข้อมูลสำเร็จ",
              deleteError: "เกิดข้อผิดพลาดในการลบข้อมูล",
              confirmDeleteModal: {
                removeHospitalImport: "ลบการนำเข้าข้อมูล",
                info1: "ต้องการลบการนำเข้าข้อมูล",
                info2: "หรือไม่",
                warningInfo: "*ข้อมูลจะถูกลบและไม่สามารถกู้คืนได้",
                cancelDelete: "ยกเลิก",
                confirmDelete: "ลบข้อมูล",
              },
              downloadSuccess: "ดาวน์โหลดสำเร็จ",
            },
            createModal: {
              createHospitalImport: "นำเข้าข้อมูล",
              name: "ชื่อการนำเข้า",
              upload: "แนบไฟล์",
              importData: "ข้อมูลการเบิก",
              importDate: "วันที่นำเข้า",
              cancelButtonLabel: "ยกเลิก",
              okButtonLabel: "เพิ่มการนำเข้า",
              createSuccess: "สร้างการนำเข้าข้อมูลสำเร็จ",
              createError: "เกิดข้อผิดพลาดในการสร้างการนำเข้าข้อมูล",
              success: "ทำรายการสำเร็จ",
            },
          },
          partnerHospitals: {
            index: {
              title: "โรงพยาบาลพันธมิตร",
              home: "หน้าแรก",
              list: "รายชื่อโรงพยาบาล",
              addPartnerHospital: "เพิ่มโรงพยาบาล",
              pdfSetting: "ตั้งค่า PDF",
              infoText1:
                "*พนักงานสามารถใช้สิทธิ์เบิกตรงได้เฉพาะโรงพยาบาลที่มีสถานะ “ใช้งาน” เท่านั้น",
              infoText2:
                "และระบบจะปิดไม่ให้ขอเอกสารส่งตัวถ้าไม่มีโรงพยาบาลใด “ใช้งาน” อยู่เลย",
              name: "ชื่อโรงพยาบาล",
              hospitalType: "ประเภท",
              [EnumHospitalType.GOVERNMENT]: "รัฐบาล",
              [EnumHospitalType.NON_GOVERNMENT]: "เอกชน",
              description: "คำอธิบาย",
              status: "สถานะ",
              active: "ใช้งาน",
              inactive: "ไม่ใช้งาน",
              PRIVATE: "เอกชน",
              PUBLIC: "รัฐบาล",
            },
            PartnerHospitalFilters: {
              name: "ชื่อโรงพยาบาล",
              status: "สถานะ",
              hospitalType: "ประเภท",
              active: "ใช้งาน",
              inactive: "ไม่ใช้งาน",
              [EnumHospitalType.GOVERNMENT]: "รัฐบาล",
              [EnumHospitalType.NON_GOVERNMENT]: "เอกชน",
            },
            detail: {
              home: "หน้าแรก",
              partnerHospital: "โรงพยาบาลพันธมิตร",
              addPartnerHospital: "เพิ่มโรงพยาบาลพันธมิตร",
              editPartnerHospital: "แก้ไขโรงพยาบาลพันธมิตร",
              name: "ชื่อโรงพยาบาล",
              hospitalType: "ประเภทโรงพยาบาล",
              [EnumHospitalType.GOVERNMENT]: "รัฐบาล",
              [EnumHospitalType.NON_GOVERNMENT]: "เอกชน",
              description: "คำอธิบาย",
              startEffectiveDate: "วันที่เริ่มมีผล",
              endEffectiveDate: "วันที่สิ้นสุด",
              termAndCondition: "ข้อกำหนดและเงื่อนไข",
              status: "สถานะ",
              active: "ใช้งาน",
              inactive: "ไม่ใช้งาน",
              cancel: "ยกเลิก",
              save: "บันทึก",
              saveSuccess: "บันทึกสำเร็จ",
            },
          },
          pdfSetting: {
            title: "ตั้งค่า PDF",
            mouSetting: "รายละเอียดผู้ลงนาม",
            home: "หน้าแรก",
            partnerHospital: "โรงพยาบาลพันธมิตร",
            name: "ชื่อ-นามสกุลผู้ลงนาม",
            position: "ตำแหน่ง",
            signatureImage: "ภาพลายเซ็นต์",
            signatureImageNote: "(รองรับไฟล์ jpg/png แนะนำขนาด 460x300 pixel)",
            upload: "แนบไฟล์",
            cancel: "ยกเลิก",
            save: "บันทึก",
            saveSuccess: "บันทึกสำเร็จ",
            validation: {
              name: {
                required: "กรุณากรอกชื่อ-นามสกุลผู้ลงนาม",
              },
              position: {
                required: "กรุณากรอกตำแหน่ง",
              },
              signatureImage: {
                required: "กรุณาอัพโหลดภาพลายเซ็นต์",
              },
            },

            governmentSection: "ข้อความสำหรับโรงพยาบาลรัฐบาล",
          },
          employeeDelegation: {
            index: {
              title: "กำหนดสิทธิ์ทำแทนพนักงาน",
              home: "หน้าแรก",
              list: "รายการสิทธิ์",
              delegateName: "ผู้มีสิทธิ์ทำแทน",
              mode: "สิทธิ์ทำแทนพนักงาน",
              updatedAt: "วันที่อัพเดทล่าสุด",
              addEmployeeDelegation: "เพิ่มผู้ทำแทน",
              success: "ทำรายการสำเร็จ",

              confirmDeleteModal: {
                removeTitle: "ลบผู้มีสิทธิ์ทำแทน",
                info1: "ต้องการลบผู้มีสิทธิ์ทำแทน",
                info2: "หรือไม่",
                cancelDelete: "ปิดหน้าต่างนี้",
                confirmDelete: "ลบ",
              },
            },
            edit: {
              title: "แก้ไขผู้ทำแทน",
              home: "หน้าแรก",
              employeeDelegation: "กำหนดสิทธิ์ทำแทน",
              success: "ทำรายการสำเร็จ",
            },
            create: {
              title: "เพิ่มผู้ทำแทน",
              home: "หน้าแรก",
              employeeDelegation: "กำหนดสิทธิ์ทำแทน",
              success: "ทำรายการสำเร็จ",
            },
            components: {
              EmployeeDelegationForm: {
                header: "รายละเอียดผู้มีสิทธิ์ทำแทน",
                employeeDelegation: "กำหนดสิทธิ์ทำแทน",
                delegateName: "ผู้มีสิทธิ์ทำแทน",
                mode: "สิทธิ์ทำแทนพนักงาน",
                targets: "พนักงานที่ถูกทำรายการแทนได้",
                cancel: "ยกเลิก",
                save: "บันทึก",
              },
            },
          },
        },
        auth: {
          ResetPassword: {
            forgotPassword: "ลืมรหัสผ่าน",
            inputEmail: "กรอกอีเมลเพื่อสร้างรหัสผ่านในการเข้าสู่ระบบใหม่",
            send: "ส่ง",
            link1:
              "ลิงก์สำหรับสร้างรหัสผ่านใหม่ได้ถูกส่งไปที่อีเมล \n{{email}}\n",
            link2:
              "เรียบร้อยแล้ว \n กรุณาคลิกลิงก์จากอีเมลเพื่อสร้างรหัสผ่านในการเข้าสู่ระบบ",
          },
        },
      },
      components: {
        common: {
          languagesDropdown: {
            label: "ภาษา",
            lang: "ไทย",
          },
          PopMenu: {
            logout: "ออกจากระบบ",
            logoutInfo1: "คุณต้องการออกจากระบบใช่หรือไม่ หากต้องการกรุณากดปุ่ม",
            logoutInfo2: "ด้านล่างเพื่อทำการออกจากระบบ",
            confirmLogout: "ยืนยัน",
            cancel: "ยกเลิก",
            profile: "โปรไฟล์",
            avatar: "AD",
          },
          MaterialIcon: {
            notFoundIcon: "ไม่พบไอคอน",
          },
          UploadAvatar: {
            avatar: "AD",
          },
        },
        advance: {
          AddressList: {
            total: "ทั้งหมด {{amount}}",
            addressNo: "ที่อยู่ {{index}}",
          },
          FileUploadList: {
            total: "ทั้งหมด {{amount}}",
          },
          FilterTableLayout: {
            title: "ตัวกรอง",
            show: "แสดง",
            hide: "ซ่อน",
          },
          FilterTableWithQueryParams: {
            confirm: "กรอง",
            reset: "รีเซ็ต",
          },
        },
        SideBar: {
          appName: "eBenefits",
        },
        Table: {
          noData: "ไม่มีข้อมูล",
          noDataOnFilter:
            "ไม่พบข้อมูลที่ค้นหา กรุณาตรวจสอบค่าในตัวกรองอีกครั้ง",
        },
      },
      routes: {
        menu: {
          adminMenu: "ผู้ดูแลระบบ",
          roleMenu: "บทบาท",
          insuranceMenu: "จัดการชุดแบบประกัน",
          settingMenu: "ตั้งค่าระบบ",
          menu: "เมนู",
          insurance: "จัดการชุดแบบประกัน",
          enrollment: "การลงทะเบียน",
          report: "ออกรายงาน",
          employee: "พนักงาน",
          budget: "วงเงินสวัสดิการ",
          request: "รายการขอเบิก",
          fileBrowser: "ข้อมูลนำเข้า",
          paymentCycle: "รอบการจ่ายเงิน",
          hospitalImport: "การเบิกจากโรงพยาบาล",
          partnerHospital: "โรงพยาบาลพันธมิตร",
          employeeDelegation: "กำหนดสิทธิ์ทำแทน",
        },
      },
      yup: {
        error: {
          required: "ต้องไม่เว้นว่างเอาไว้",
          invalidEmailSyntax: "รูปแบบอีเมลไม่ถูกต้อง",
          typeNumber: "ต้องเป็นตัวเลข",
          GtZero: "ต้องเป็นตัวเลขมากกว่า 0",
          GteZero: "ต้องเป็นตัวเลขมากกว่าหรือเท่ากับ 0",
          passwordNotMatch: "รูปแบบรหัสผ่านไม่ถูกต้อง",
          wrongConfirmPassword: "รหัสผ่านไม่ตรงกัน",
          reportNameWarning: "กรุณากรอกชื่อรายงาน",
          reportDepartmentWarning: "กรุณาเลือกฝ่าย/สังกัด",
          relationWithOwnerWarning: "กรุณาเลือกความสัมพันธ์กับเจ้าของคำร้อง",
          startDateWarning: "กรุณาเลือกวันที่สร้างรายการ",
          endDateWarning: "กรุณาเลือกจนถึงวันที่",
          startDateCompareWarning:
            "กรุณาเลือกวันที่สำหรับรายการเปรียบเทียบตั้งแต่",
          endDateCompareWarning: "กรุณาเลือกจนถึงวันที่",
        },
      },
      validation: {
        name: {
          required: "กรุณากรอกชื่อ-นามสกุลผู้จองบน",
        },
        position: {
          required: "กรุณากรอกตำแหน่ง",
        },
        signatureImage: {
          required: "กรุณาอัพโหลดภาพลายเซ็นต์",
        },
      },
      error: {
        required: "ต้องไม่เว้นว่างเอาไว้",
        saveError: "แบบประกันนี้ถูกเผยแพร่แล้ว",
        accept: "ตกลง",
        saveErrorChildren:
          "การลงทะเบียนนี้ถูกเผยแพร่ไปแล้ว กรุณากดปุ่ม (ตกลง) เพื่อ refresh และลองใหม่อีกครั้ง",
        reportTypeWarning: "กรุณาเลือกประเภทรายงาน",
      },
    },
  },
};

export default th;
